import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminUpdateTranslationMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminUpdateTranslationMutationResultFragment, AdminUpdateTranslationMutationParams } from '@docpace/admin-graphql'

const typedAdminUpdateTranslationMutationDocument = AdminUpdateTranslationMutationDocument as TypedDocumentNode<AdminUpdateTranslationMutationResultFragment, Partial<AdminUpdateTranslationMutationParams>>

export function useAdminUpdateTranslationMutation(opts?: useMutation.Options<AdminUpdateTranslationMutationResultFragment, Partial<AdminUpdateTranslationMutationParams>>){
    return useMutation(typedAdminUpdateTranslationMutationDocument, opts)
}
